<template>
  <div class="p-1">
    <ul class="nav text-small">
      <li data-toggle="dropdown" :data-bs-toggle="user ? 'dropdown' : ''" aria-expanded="true">
        <router-link :to="!user || !token ? '/login' : '#'" class="vert-centered nav-link text-white p-0">
          <div id="loginPhoto" v-if="isActiveLogin()" :class="`d-block nlhpc-numberCircle ${!user.foto ? 'ms-3' : ''}`"
            data-bs-toggle="tooltip" data-bs-placement="bottom" :title="user ? user.Nombre : ''" :style="getFoto()">
            <span v-if="user && !user.foto" style="font-size: xx-large; font-weight: medium">
              {{ user.Nombre.substring(0, 1) }}
            </span>
            <span v-if="!this.$nlhpc.isLoggedIn()">
              <i class="fas fa-user-alt fa-xs"></i>
            </span>
          </div>

          <ul v-if="user" class="dropdown-menu dropdown-menu-end mt-0 me-2">
            <li class="dropdown-item" @click="goToUrl('/profile')">
              <router-link :to="'/profile'" style="color: var(--negro)">
                <span style="font-size: large">{{ user.Nombre }}</span>
                <br />
                <span v-if="!!user.usuario">Usuario:&nbsp;{{ user.usuario }}</span>
                <span v-else>Investigador Responsable</span>
              </router-link>
            </li>
            <li class="dropdown-item my-2" @click="this.$nlhpc.modalUnban(user)">
              <router-link :to="'/conexiones'" style="color: var(--negro)">
                <span style="color:var(--text-danger)">Revisar bloqueo de IP</span>
              </router-link>
            </li>
            <li class="break">
              <hr class="my-1 ms-2" style="margin-right: 0.5rem !important" />
            </li>
            <li class="dropdown-item" @click="unLogin()">
              <div class="text-center">
                <a href="#" @click="unLogin()"> Cerrar sesión </a>
              </div>
            </li>
          </ul>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "HeaderLogin",
  data() {
    return {
      user: null,
      token: null,
    };
  },

  created() {
    this.token = localStorage.getItem("token");
    this.user = JSON.parse(localStorage.getItem("user") || false);
  },

  mounted() {
    this.user = JSON.parse(localStorage.getItem("user") || false);
    window.addEventListener("storage", () => {
      this.fixDropdowns();
    });
  },

  updated() {
    this.token = localStorage.getItem("token");
    this.fixDropdowns();
  },

  methods: {
    async unLogin() {
      this.$swal({
        html: `<span style="font-size: 1.2em;">¿Realmente desea cerrar su sesión?</span>`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Si, cerrar",
        cancelButtonText: `Cancelar`,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: "btn",
        },
      }).then((result) => {
        if (result.isConfirmed) {
          localStorage.removeItem("token");
          localStorage.removeItem("user");
          location.href = "/";
        }
      });
    },

    fixDropdowns() {
      this.theme = localStorage.getItem("_theme");
      const dropdowns = document.querySelectorAll(".dropdown-menu");
      dropdowns.forEach((item) => {
        if (this.theme == "dark") item.classList.add("dropdown-menu-dark");
        else item.classList.remove("dropdown-menu-dark");
      });
    },

    goToUrl(url) {
      this.$router.push(`${url}`);
    },

    isActiveLogin() {
      if (this.user) return true;
      return process.env.VUE_APP_LOGIN_ACTIVE === "true" ? true : false;
    },

    getFoto() {
      return this.user.foto
        ? `background-image: url(data:image/jpeg;base64,${this.user.foto});background-size: cover; background-position: center`
        : "";
    },
  },
};
</script>

<style scoped>
ul * {
  font-size: small;
}
</style>
